import { LinearProgress } from "@mui/material";
import { withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const TransparentProgress = withStyles(LinearProgress, {
  root: {
    height: 3,
    width: "100%",
    backgroundColor: "transparent",
  },
  bar: {
    backgroundColor: colors.gray,
  },
});

export default TransparentProgress;
